import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const FlashMemory = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M4.332.69h7.333v3.666a.333.333 0 1 1-.666 0v-3h-6v3a.333.333 0 1 1-.667 0V.689Z" />
        <path d="M6.665 2.355c.184 0 .334.15.334.334v1.333a.333.333 0 0 1-.667 0V2.69c0-.184.15-.334.333-.334ZM9.333 2.355c.184 0 .334.15.334.334v1.333a.333.333 0 0 1-.667 0V2.69c0-.184.15-.334.333-.334ZM2.666 5.69h10.666v8.666a1.666 1.666 0 0 1-1.666 1.666H4.333a1.666 1.666 0 0 1-1.667-1.666V5.689Zm.667.666v8a1 1 0 0 0 1 1h7.333a1 1 0 0 0 1-1v-8H3.333Z" />
        <path d="M4.666 7.69h6.666v4.333H4.666V7.689Zm.667.666v3h5.333v-3H5.333Z" />
      </g>
    </svg>
  );
};

FlashMemory.category = 'product-category';

FlashMemory.displayName = 'FlashMemory';
